import React from 'react'
import Layout from '../../Layout'
import AllTaxiRequestContainer from '../../../../Components/Taxi/AllTaxiRequestContainer/AllTaxiRequestContainer'

const AllTaxiRequest = () => {
  return (
    <Layout><AllTaxiRequestContainer/></Layout>
  )
}

export default AllTaxiRequest